/*
 * @Author: chengyu
 * @Date: 2022-11-28 11:42:28
 * @Description: 发布订阅
 * https://decipher.dev/30-seconds-of-typescript/docs/createEventHub
 */
/**
 * 发布订阅
 *
 * ```typescript
 *
 * interface User {
 *   name: string;
 * }
 * let user: User | undefined;
 * const userEmitter = createEventHub<User>();
 * const updateUser = (u: User) => (user = u);
 * userEmitter.on("update", updateUser);
 * userEmitter.emit("update", { name: "Deepak" });
 *
 * assertEquals(user, { name: "Deepak" });
 *
 * ```
 */
var createEventHub = function () { return ({
    hub: Object.create(null),
    emit: function (event, data) {
        (this.hub[event] || []).forEach(function (handler) {
            return handler(data);
        });
    },
    on: function (event, handler) {
        if (!this.hub[event])
            this.hub[event] = [];
        this.hub[event].push(handler);
    },
    off: function (event, handler) {
        var _a;
        var i = (this.hub[event] || []).findIndex(function (h) { return h === handler; });
        if (i > -1)
            this.hub[event].splice(i, 1);
        if (((_a = this.hub[event]) === null || _a === void 0 ? void 0 : _a.length) === 0)
            delete this.hub[event];
    },
}); };
export default createEventHub;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY3JlYXRlRXZlbnRIdWIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY29yZS91dGlscy9sb2Rhc2gvY3JlYXRlRXZlbnRIdWIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7O0dBS0c7QUFJSDs7Ozs7Ozs7Ozs7Ozs7Ozs7R0FpQkc7QUFDSCxJQUFNLGNBQWMsR0FBRyxjQUFpQixPQUFBLENBQUM7SUFDdkMsR0FBRyxFQUFFLE1BQU0sQ0FBQyxNQUFNLENBQUMsSUFBSSxDQUFDO0lBQ3hCLElBQUksWUFBQyxLQUFhLEVBQUUsSUFBUTtRQUMxQixDQUFDLElBQUksQ0FBQyxHQUFHLENBQUMsS0FBSyxDQUFDLElBQUksRUFBRSxDQUFDLENBQUMsT0FBTyxDQUFDLFVBQUMsT0FBNEI7WUFDM0QsT0FBQSxPQUFPLENBQUMsSUFBSSxDQUFDO1FBQWIsQ0FBYSxDQUNkLENBQUM7SUFDSixDQUFDO0lBQ0QsRUFBRSxZQUFDLEtBQWEsRUFBRSxPQUFnQjtRQUNoQyxJQUFJLENBQUMsSUFBSSxDQUFDLEdBQUcsQ0FBQyxLQUFLLENBQUM7WUFBRSxJQUFJLENBQUMsR0FBRyxDQUFDLEtBQUssQ0FBQyxHQUFHLEVBQUUsQ0FBQztRQUMzQyxJQUFJLENBQUMsR0FBRyxDQUFDLEtBQUssQ0FBQyxDQUFDLElBQUksQ0FBQyxPQUFPLENBQUMsQ0FBQztJQUNoQyxDQUFDO0lBQ0QsR0FBRyxZQUFDLEtBQWEsRUFBRSxPQUFnQjs7UUFDakMsSUFBTSxDQUFDLEdBQUcsQ0FBQyxJQUFJLENBQUMsR0FBRyxDQUFDLEtBQUssQ0FBQyxJQUFJLEVBQUUsQ0FBQyxDQUFDLFNBQVMsQ0FBQyxVQUFDLENBQVUsSUFBSyxPQUFBLENBQUMsS0FBSyxPQUFPLEVBQWIsQ0FBYSxDQUFDLENBQUM7UUFDM0UsSUFBSSxDQUFDLEdBQUcsQ0FBQyxDQUFDO1lBQUUsSUFBSSxDQUFDLEdBQUcsQ0FBQyxLQUFLLENBQUMsQ0FBQyxNQUFNLENBQUMsQ0FBQyxFQUFFLENBQUMsQ0FBQyxDQUFDO1FBQ3pDLElBQUksQ0FBQSxNQUFBLElBQUksQ0FBQyxHQUFHLENBQUMsS0FBSyxDQUFDLDBDQUFFLE1BQU0sTUFBSyxDQUFDO1lBQUUsT0FBTyxJQUFJLENBQUMsR0FBRyxDQUFDLEtBQUssQ0FBQyxDQUFDO0lBQzVELENBQUM7Q0FDRixDQUFDLEVBaEJzQyxDQWdCdEMsQ0FBQztBQUVILGVBQWUsY0FBYyxDQUFDIn0=